// Lo que decide la ficha de Nexo sobre qué partes pinta, sin React, para probarlo con Deno con los casos de oro
// (app/scripts/nexo-ficha.test.ts). No redacta: elige textos del documento.
import type { Hallazgos } from "../../../shared/piezas/index.ts";

/**
 * La primera pregunta («¿Es la misma persona que tu cliente?») sin comparación con el cliente (Nexo no pide sus datos): lo que el
 * documento dice de la identidad, en este orden: la persona encontrada frente a la lista, la agrupación y la tarjeta unida.
 */
export function textosPrimeraPregunta(doc: Hallazgos): string[] {
  return [doc.identidad_lista?.texto, doc.sujeto.agrupado?.texto, doc.sujeto.coinciden_con_lista?.texto].filter((t): t is string => !!t);
}

/** «Qué hacer»: sólo con hallazgos (sin hallazgos no hay pasos, diseño §2.13). */
export function pasosQueHacer(doc: Hallazgos): string[] {
  return doc.nivel.valor === "sin_hallazgos" ? [] : doc.que_hacer;
}

/** La liga oficial de una fuente: sólo `https` (la copia guardada es del corte 4b). */
export function ligaOficial(url: string | null | undefined): string | null {
  return url && /^https:\/\//.test(url) ? url : null;
}
